'use client';

import { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import './RefundPolicy.css';
import { Link } from 'react-router-dom';

export default function RefundPolicy() {
  const [openRefundAccordion, setOpenRefundAccordion] = useState(null);
  const [openCancellationAccordion, setOpenCancellationAccordion] =
    useState(null);

  const refundsections = [
    {
      title: 'Refund Window',
      content:
        'We offer a 30-day money-back guarantee on all purchases. If you are not completely satisfied with your purchase, you can request a full refund within 30 days of the purchase date. No questions asked.',
    },
    {
      title: 'How to Request a Refund',
      content:
        'To request a refund, please contact our customer support team at contact@memoriesmakeredu.com with your order number and reason for the refund. Our team will process your request within 5-7 business days and provide you with instructions for returning the product.',
    },

    {
      title: 'Refund Processing Time',
      content:
        'Once we receive confirmation of your cancellation and all required documents, we will review and process your refund within 7–10 business days. The refund will be credited to your original mode of payment. Please allow an additional 3–5 business days for the amount to reflect in your account, depending on your bank or payment provider.',
    },
  ];
  const cancellationsections = [
    {
      title: 'International Tours',
      content: [
        '120+ days before departure: 20% cancellation charges',
        '61-120 days before departure: 50% cancellation charges',
        '30-60 days before departure: 75% cancellation charges',
        'Within 30 days of departure: 100% cancellation charges',
      ],
    },
    {
      title: 'Domestic Tours',
      content: [
        'INR 3,000 is non-refundable at all times.',
        '60-120 days before departure: 75% refund of the total tour cost.',
        '30-59 days before departure: 50% refund of the total tour cost.',
        '15-29 days before departure: 25% refund of the total tour cost.',
        'Within 15 days of departure: No refund.',
      ],
    },
  ];

  const toggleRefundAccordion = (index) => {
    setOpenRefundAccordion(openRefundAccordion === index ? null : index);
  };

  const toggleCancellationAccordion = (index) => {
    setOpenCancellationAccordion(
      openCancellationAccordion === index ? null : index,
    );
  };

  return (
    <>
      <Header />
      <div className="refund-page">
        <div className="refund-hero">
          <div className="refund-hero-overlay"></div>
          <div className="refund-hero-content">
            <h1 className="refund-hero-title">Refund & Cancellation Policy</h1>
            <p className="refund-hero-subtitle">
              We want you to be completely satisfied with your purchase
            </p>
          </div>
        </div>

        <div className="refund-cards">
          {[
            { icon: '🛡️', title: '30 Days', desc: 'Money-back guarantee' },
            {
              icon: '✨',
              title: 'Easy Process',
              desc: 'Simple refund requests',
            },
            {
              icon: '⚡',
              title: 'Fast Support',
              desc: 'Quick customer service',
            },
          ].map((card, idx) => (
            <div key={idx} className="refund-card">
              <div className="refund-card-topline"></div>
              <div className="refund-card-icon">{card.icon}</div>
              <h3 className="refund-card-title">{card.title}</h3>
              <p className="refund-card-desc">{card.desc}</p>
            </div>
          ))}
        </div>

        <div className="refund-accordion-area">
          <h2 className="refund-section-title">Refund Details</h2>
          {refundsections.map((section, index) => (
            <div key={index} className="refund-accordion">
              <button
                onClick={() => toggleRefundAccordion(index)}
                className={`refund-accordion-button${
                  openRefundAccordion === index ? ' open' : ''
                }`}
              >
                <span>{section.title}</span>
                <span
                  className={`refund-accordion-icon${
                    openRefundAccordion === index ? ' open' : ''
                  }`}
                >
                  {openRefundAccordion === index ? '−' : '+'}
                </span>
              </button>
              {openRefundAccordion === index && (
                <div className="refund-accordion-content">
                  <p>{section.content}</p>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="refund-accordion-area">
          <h2 className="refund-section-title">Cancellation Details</h2>
          {cancellationsections.map((section, index) => (
            <div key={index} className="refund-accordion">
              <button
                onClick={() => toggleCancellationAccordion(index)}
                className={`refund-accordion-button${
                  openCancellationAccordion === index ? ' open' : ''
                }`}
              >
                <span>{section.title}</span>
                <span
                  className={`refund-accordion-icon${
                    openCancellationAccordion === index ? ' open' : ''
                  }`}
                >
                  {openCancellationAccordion === index ? '−' : '+'}
                </span>
              </button>
              {openCancellationAccordion === index && (
                <div className="refund-accordion-content">
                  {Array.isArray(section.content) ? (
                    <ul className="refund-accordion-list">
                      {section.content.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                      ))}
                    </ul>
                  ) : (
                    <p>{section.content}</p>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="refund-cta">
          <div className="refund-cta-bg"></div>
          <div className="refund-cta-content">
            <h2 className="refund-cta-title">Have Questions?</h2>
            <p className="refund-cta-text">
              Our customer support team is here to help you 24/7
            </p>
            <Link to="/contact">
              <button className="refund-cta-button">Contact Support</button>
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
